import React, { useState, useEffect, useRef } from 'react';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import Grid from '../../../../../Grid';
import GridItem from '../../../../../GridItem';

import Tooltip from '../../../Tooltip';

import { useCardContext } from '../../../../index';

import styles, { mainCls, mapCls } from './style';

const useStyles = createStyle(styles);

export default function Description({ depthInfos, details, description, vWidth }) {
  

  const { maplist } = useCardContext() || {};
  const isMaplist = maplist || false;


  const cls = useStyles();

  const desc = useRef(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [descriptionHeightWhenExpanded, setDescriptionHeightWhenExpanded] = useState(0);
  const [containerHeightWhenExpanded, setContainerHeightWhenExpanded] = useState(0);

  useEffect(() => {
    const { current: detailsEl } = details;
    const { current: descEl } = desc;
    if (descEl) {
      if (descEl.scrollHeight > descEl.clientHeight) {
        descEl.style.maxHeight = `${descEl.clientHeight}px`;
        detailsEl.style.minHeight = `${detailsEl.clientHeight}px`;
        setDescriptionHeightWhenExpanded(descEl.scrollHeight);
        setContainerHeightWhenExpanded(detailsEl.clientHeight + (descEl.scrollHeight - descEl.clientHeight))
      } else {
        setIsExpanded(true);
      }
    }
  }, []);

  useEffect(() => {
    if (!isExpanded) {
      const { current: detailsEl } = details;
      const { current: descEl } = desc;
      if (descEl) {
        descEl.style.maxHeight = '';
        detailsEl.style.minHeight = '';
        setTimeout(() => {
          if (descEl.scrollHeight > descEl.clientHeight) {
            descEl.style.maxHeight = `${descEl.clientHeight}px`;
            detailsEl.style.minHeight = `${detailsEl.clientHeight}px`;
            setDescriptionHeightWhenExpanded(descEl.scrollHeight);
            setContainerHeightWhenExpanded(detailsEl.clientHeight + (descEl.scrollHeight - descEl.clientHeight))
          }
        }, 100);
      }
    }
  }, [isExpanded, vWidth]);

  const expand = () => {
    const { current: detailsEl } = details;
    const { current: descEl } = desc;
    descEl.style.maxHeight = `${descriptionHeightWhenExpanded}px`;
    detailsEl.style.minHeight = `${containerHeightWhenExpanded}px`;
    setDescriptionHeightWhenExpanded(0);
    setIsExpanded(true);
  };

  const descCls = makeClassName([
    isMaplist ? cls[`${mapCls}__desc`] : cls[`${mainCls}__desc`],
    !isExpanded && 'clamped',
    'tp-s--s tp-w--s c-txt--f5',
    depthInfos.descClamp,
  ]);

  return (
    <GridItem
      className={cls[`${isMaplist ? mapCls : mainCls}__descCont`]}
      behavior="fixed"
    >
      <Grid align="flex-end">
        <p
          ref={desc}
          className={descCls}
        >
          {description}
        </p>
        <Tooltip
          text="Espandi"
          topCoords={-39}
          className={`${cls[`${mainCls}__desc--expandCont`]}${descriptionHeightWhenExpanded ? ' visible' : ''} ml--s is-rel`}
        >        
          <button
            type="button"
            className={`${cls[`${mainCls}__desc--expand`]} c-bg--w b--s is-rel is-clickable`}
            onClick={expand}
          />
        </Tooltip>
      </Grid>
    </GridItem>
  );
}